export default "__VITE_ASSET__X7odoKod__"